import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import {
  bannerImgOne,
  bannerImgTwo,
  bannerImgThree,
  bannerImgFour,
} from "../../assets/images";
import Image from "../designLayouts/Image";

/**
 * SEO-Optimized Banner Component
 * Displays a responsive, keyword-rich carousel with trade & export promotion banners
 * Includes semantic links, alt text, and proper heading structure for SEO
 */
const Banner = () => {
  const [activeDot, setActiveDot] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (prev, next) => setActiveDot(next),
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "5%",
          transform: "translateY(-50%)",
        }}
      >
        <ul style={{ margin: 0 }}>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === activeDot
            ? {
                width: "30px",
                color: "#262626",
                borderRight: "3px solid #262626",
                padding: "8px 0",
                cursor: "pointer",
              }
            : {
                width: "30px",
                color: "transparent",
                borderRight: "3px solid white",
                padding: "8px 0",
                cursor: "pointer",
              }
        }
        aria-label={`Slide ${i + 1}`}
      >
        0{i + 1}
      </div>
    ),
    responsive: [
      {
        breakpoint: 576,
        settings: {
          dots: true,
          appendDots: (dots) => (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "2%",
                transform: "translateY(-50%)",
              }}
            >
              <ul style={{ margin: 0 }}>{dots}</ul>
            </div>
          ),
          customPaging: (i) => (
            <div
              style={
                i === activeDot
                  ? {
                      width: "25px",
                      color: "#262626",
                      borderRight: "3px solid #262626",
                      fontSize: "12px",
                      cursor: "pointer",
                    }
                  : {
                      width: "25px",
                      color: "transparent",
                      borderRight: "3px solid white",
                      fontSize: "12px",
                      cursor: "pointer",
                    }
              }
              aria-label={`Slide ${i + 1}`}
            >
              0{i + 1}
            </div>
          ),
        },
      },
    ],
  };

  // Array of banner images with SEO-friendly alt text
  const banners = [
    { img: bannerImgOne, alt: "Premium Exported Red Onions from India", link: "/offer" },
    { img: bannerImgTwo, alt: "Fresh Carrots for International Trade", link: "/offer" },
    { img: bannerImgThree, alt: "High Quality Cucumbers for Global Export", link: "/offer" },
    { img: bannerImgFour, alt: "Mixed Fresh Chilies for Export and Trade", link: "/offer" },
  ];

  return (
    <section className="w-full relative bg-white">
      <Slider {...settings}>
        {banners.map((banner, index) => (
          <Link key={index} to={banner.link} aria-label={`Banner Slide ${index + 1}`}>
            <div>
              <Image imgSrc={banner.img} alt={banner.alt} />
            </div>
          </Link>
        ))}
      </Slider>
    </section>
  );
};

export default Banner;
